import React from "react";
var __jsx = React.createElement;
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useFieldError } from 'libs/content/hooks';
import { Chevron } from 'theme/icons';

var SelectInput = function SelectInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      options = _ref.options,
      defaultValue = _ref.defaultValue,
      allowEmpty = _ref.allowEmpty;
  var intl = useIntl();

  var _useFormContext = useFormContext(),
      control = _useFormContext.control;

  var errorMessage = useFieldError(name);
  return __jsx(Controller, {
    control: control,
    name: name,
    defaultValue: defaultValue,
    render: function render(_ref2) {
      var _ref2$field = _ref2.field,
          onChange = _ref2$field.onChange,
          value = _ref2$field.value;
      return __jsx(FormControl, {
        variant: "outlined",
        error: Boolean(errorMessage),
        fullWidth: true
      }, __jsx(InputLabel, {
        id: "form-field-".concat(name, "-label")
      }, label), __jsx(Select, {
        id: "form-field-".concat(name),
        labelId: "form-field-".concat(name, "-label"),
        onChange: onChange,
        name: name,
        value: value,
        defaultValue: defaultValue,
        label: label,
        IconComponent: Chevron
      }, allowEmpty && __jsx(MenuItem, null, intl.formatMessage({
        id: 'selectField.options.none'
      })), options.map(function (_ref3) {
        var option = _ref3.option,
            labelId = _ref3.labelId;
        return __jsx(MenuItem, {
          key: option,
          value: option
        }, intl.formatMessage({
          id: labelId
        }));
      })), __jsx(FormHelperText, null, errorMessage));
    }
  });
};

export default SelectInput;